import { LogLevel } from '@grafana/faro-web-sdk';
import { BoardSettings } from '../../../model/board-settings';
import { Currency } from '../../../model/enums/currency';
import { LoggingService } from '../../logging.service';
import { ApiBoardSettingsResponse } from '../../../api/core/models';
import { BoardSettingsV2 } from '../model';

export function apiBoardSettingsToCurrency(
  loggingService: LoggingService,
  apiBoardSettings?: ApiBoardSettingsResponse
): BoardSettingsV2['currency'] {
  switch (apiBoardSettings?.currency) {
    case 'CAD':
      return Currency.CanadianDollar;
    case 'CHF':
      return Currency.SwissFranc;
    case 'EUR':
      return Currency.Euro;
    case 'GBP':
      return Currency.PoundSterling;
    case 'SEK':
      return Currency.SwedishKrona;
    case 'USD':
      return Currency.USDollar;
    default:
      loggingService.logMessage(
        `Board has unsupported currency: ${apiBoardSettings?.currency}`,
        undefined,
        LogLevel.WARN
      );
      return Currency.Euro;
  }
}
